import React from 'react';
import { useProfileInfo } from './profile-context';

interface AttemptsCounterProps {
    attemptsLeft: number | null;
}

const AttemptsCounter: React.FC<AttemptsCounterProps> = () => {
    const { state: { attemptsLeft}} = useProfileInfo();
    return (
        <p
            style={{
                color: 'red',
                textAlign: 'right',
                fontSize: 15,
                paddingBottom: '12px',
            }}
            className="text-right"
        >
            {attemptsLeft === null ? 0 : attemptsLeft} of 10 attempts remaining
        </p>
    );
};

export default AttemptsCounter;
